export const getEmailCollectorAddress = () => {
  return "0x98380024AD6a0705A535d554DF051Cd2C5912c0c"
}